// @flow

// Move this to stringUtils

export const filename = function(filename: string): string {
  return filename.replace(/[^-\w]+/gi, '_', '');
};

export default {
  filename
};
